<template>
  <div>
    <h2 class="subtitle has-text-weight-bold">
      {{ $t("billing.summary") }}
    </h2>

    <div class="columns">
      <div class="column">
        <b-field
          :label="$t('billing.POStotalValue')"
          label-position="on-border"
        >
          <money
            :value="POStotalValue"
            v-bind="money"
            class="input is-expanded"
            disabled
          ></money>
        </b-field>
      </div>

      <div class="column">
        <b-field label="Soma mensalidades TEF" label-position="on-border">
          <money
            :value="tefTotalValue"
            v-bind="money"
            class="input is-expanded"
            disabled
          ></money>
        </b-field>
      </div>

      <div class="column">
        <b-field
          :label="$t('billing.systemTotalValue')"
          label-position="on-border"
        >
          <money
            :value="systemTotalValue"
            v-bind="money"
            class="input is-expanded"
            disabled
          ></money>
        </b-field>
      </div>

      <div class="column">
        <b-field :label="$t('billing.totalValue')" label-position="on-border">
          <money
            :value="totalValue"
            v-bind="money"
            class="input is-expanded"
            disabled
          ></money>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Money } from "v-money";

export default {
  props: ["stores"],

  data() {
    return {
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2
      }
    };
  },

  components: {
    Money
  },

  computed: {
    ...mapGetters(["payments"]),

    POStotalValue() {
      let total = 0;
      this.stores.forEach(store => {
        total += store.storeInfo.POSvalue / 100;
      });
      return total;
    },

    systemTotalValue() {
      let total = 0;
      this.stores.forEach(store => {
        total += store.storeInfo.systemValue / 100;
      });
      return total;
    },

    tefTotalValue() {
      let total = 0;
      this.stores.forEach(store => {
        total += store.storeInfo.tefValue ? store.storeInfo.tefValue / 100 : 0;
      });
      return total;
    },

    totalValue() {
      return this.POStotalValue + this.systemTotalValue + this.tefTotalValue;
    }
  },

  mounted() {
    this.money.prefix = `${this.payments.currencySymbol} `;
  }
};
</script>
